var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('global.webmail')}},[(_vm.isOpening || _vm.loading)?_c('LoadingState'):_c('CardActionContent',{attrs:{"description":_vm.webmailDescription,"buttons":_vm.webmailActions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }